import { createAsyncThunk } from '@reduxjs/toolkit'
import MetricDeployment from './metric-deployment-model'
import {
  delete_metricDeployment,
  load_metricDeployments,
  store_metricDeployment,
} from './metricDeployment-service'

export const LoadMetricDeploymentsAsync = createAsyncThunk<any, any>(
  'composer/load/metricDeployment',
  async (params: { uid: string }) => {
    return await load_metricDeployments(params)
  },
)

export const CreateMetricDeploymentAsync = createAsyncThunk<any, any>(
  'composer/create/metricDeployment',
  async (params: MetricDeployment) => {
    return await store_metricDeployment(params)
  },
)

export const DeleteMetricDeploymentAsync = createAsyncThunk<any, any>(
  'composer/delete/metricDeployment',
  async (params) => {
    return await delete_metricDeployment(params)
  },
)
